import { render } from "./spinner-loader.vue?vue&type=template&id=763a8ce9&ts=true"
import script from "./spinner-loader.vue?vue&type=script&lang=ts"
export * from "./spinner-loader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__